import { render, staticRenderFns } from "./ProjectChrome.vue?vue&type=template&id=08bc675e&"
import script from "./ProjectChrome.vue?vue&type=script&lang=js&"
export * from "./ProjectChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports